module.exports = __webpack_public_path__ + "img/GroupN10.bee25612.png";